<ng-container *ngFor="let lead of leads">
  <a
    *ngIf="lead.canOpen; else readonlyLead"
    (click)="rowClick.emit()"
    routerLink="/leads/{{ lead.id }}"
    class="row striped-row py-1"
  >
    <search-client-row (assignLead)="assignLead.emit(lead)" [item]="$any(lead)" />
  </a>
  <ng-template #readonlyLead>
    <div class="row striped-row py-1">
      <search-client-row (assignLead)="assignLead.emit(lead)" [item]="$any(lead)" />
    </div>
  </ng-template>
</ng-container>
